import React from "react"

import { Container, TextWrapper, DisclaimerLink, For, Image } from "./styles"

const PartnerSponsorHeadline = ({ partner, sponsor }) => {
  const entity = partner || sponsor

  return (
    <Container>
      <TextWrapper>
        <DisclaimerLink href="/sponsor-disclaimer" target="_blank" rel="noreferrer">
          {partner ? "paid content" : <For>sponsored by</For>}
        </DisclaimerLink>
        {partner && <For>&nbsp;for</For>}
        {(entity.previewLogo || entity.logo) && (
          <a href={`/partner/${entity.url}`}>
            <Image
              baseUrl={entity.previewLogo || entity.logo}
              images={[
                {
                  transforms: "e_trim/h_22,q_auto,f_auto,fl_lossy",
                },
              ]}
              alt={entity.name}
              fetchpriority="high"
            />
          </a>
        )}
      </TextWrapper>
    </Container>
  )
}

export default PartnerSponsorHeadline
